import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ExchangeUserPairsFilter from "./ExchangeUserPairsFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ExchangeUserPairsList from "./ExchangeUserPairsList";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";
import { HTTP_STATUSES } from "../../../../utils/consts";

import MaterialPagination from "../../../styles/materialPagination";
import { StyledExchangeUserPairsWrapper } from "./styledExchangeUserPairs";

const ExchangeUserPairsContainer = () => {
  const { t } = useTranslation("exchangerPage");

  const [userPairs, setUserPairs] = useState();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "exchange-user-pairs", false, true),
    "user.email": checkFilterItem(history, "user.email", null),
    "user.nickname": checkFilterItem(history, "user.nickname", null),
    "exchangePair.inService.name": checkFilterItem(history, "exchangePair.inService.name", null),
    "exchangePair.inCurrency.asset": checkFilterItem(history, "exchangePair.inCurrency.asset", null),
    "exchangePair.outService.name": checkFilterItem(history, "exchangePair.outService.name", null),
    "exchangePair.outCurrency.asset": checkFilterItem(history, "exchangePair.outCurrency.asset", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
  });

  const [totalPageCount, setTotalPageCount] = useState(null);

  const fetchUserPairs = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/user-exchange-pairs" + filterUrl, userAuthenticationConfig()).then(response => {
      if(response.status === HTTP_STATUSES.HTTP_OK) {
        setUserPairs(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"])
      }
    })
  }

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchUserPairs();
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <Helmet>
        <title>{t("userPairs.meta.title")}</title>
      </Helmet>
      <StyledExchangeUserPairsWrapper>
        <div className="exchange-user-pairs-head">
          <ExchangeUserPairsFilter
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ExchangeUserPairsList
          userPairs={userPairs}
          notification={notification}
          setNotification={setNotification}
          fetchUserPairs={fetchUserPairs}
        />
        {totalPageCount > 1  &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />}
      </StyledExchangeUserPairsWrapper>
    </>
  )
}

export default ExchangeUserPairsContainer;